/**
 * サーバー通信(外部API等)エラークラス
 */
export class ServerError {
  /**
   * サーバー通信時URL
   */
  _url: string;

  /**
   * エラーステータス
   */
  _status: string;

  /**
   * サーバー エラーメッセージ
   */
  _message: string;

  /**
   * コンストラクタ
   * @param url URL
   * @param status ステータス
   * @param message メッセージ
   */
  constructor(url: string, status: string, message: string) {
    this._url = url;
    this._status = status;
    this._message = message;
  }
}